export async function makeshortlink(url: string) {
    if (!url) {
        return
    }
    try {
        const response = await fetch('https://h5server.betfuguapi.com/shorturl', {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
            },
            body: JSON.stringify({
                text: url,
            }),
        })

        if (!response) {
            throw new Error(`HTTP error! status: ${response}`)
        }

        return response.text()
        console.log('响应数据:', response)
    } catch (error) {
        console.error('请求错误:', error)
    }
}
